<div class="d-flex flex-column busy-overlay-parent" [ngClass]="isLoading||isSaving||!logService.isReady()?'disabled':''">

    <div *ngIf="isLoading||isSaving||!logService.isReady()" class="font-weight-bold busy-overlay"><i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...</div>

    <div *fesListView="let viewLogEntries of logEntries">
        <table class="comment-table table table-striped table-bordered table-sm mb-1 w-100">
            <thead>
            <tr>
                <th style="border-right:none;" class="w-100" fesSortField="timestamp">
                    Comments
                </th>
                <th style="border-left:none;text-align: right;">
                    <button *ngIf="!isEditing&&editable" (click)="isEditing=true" class="add-log-btn btn btn-secondary"><i class="fa fa-plus-square"></i>&nbsp;Add</button>
                </th>
            </tr>
            <tr *ngIf="isEditing">
                <td colspan=2>
                    <div class="d-flex flex-fill">
                    <textarea class="flex-fill" rows=4
                        placeholder="Enter comments here"
                        [formControl]="comments">
                    </textarea>
                    </div>
                    <div class="d-flex flex-row justify-content-end p-2">
                        <button (click)="onSaveComment()" [disabled]="comments.invalid" class="btn btn-secondary btn-sm small mr-2">Save</button>
                        <button (click)="onCancelComment()" class="btn btn-secondary btn-sm small">Cancel</button>
                    </div>
                </td>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="!isLoading&&viewLogEntries.length==0">
                <td colspan=2 class="text-muted italic">No entries found</td>
            </tr>
            <tr *ngFor="let entry of viewLogEntries">
                <ng-container *ngIf="!entry.archived; else elseBlock">
                    <td colspan=2>
                        <div class="comment-date">{{entry.timestamp|date:'yyyy-MM-dd HH:mm:ss'}}</div>
                        <div class="delete-log">
                            <i role="button" (click)="archive(entry,true)">[delete]</i>
                        </div>
                        <div>{{entry.text}}</div>
                    </td>
                </ng-container>
                <ng-template #elseBlock>
                    <td *ngIf="showDeleted" class="deleted-row" colspan=2>
                        <div class="deleted-text">{{entry.text}}</div>
                        <div class="restore-log">
                            <i role="button" (click)="archive(entry,false)">[restore]</i>
                        </div>
                    </td>
                </ng-template>
            </tr>
            </tbody>
        </table>
        <div [ngClass]="logEntries.length ? 'd-flex flex-row justify-content-between' : 'd-none'">
            <div class="w-100 pr-1">
                <input *ngIf="logEntries.length > 4" type="text" fesFilterField="text" class="w-100" placeholder="Filter comments...">
            </div>
            <div *ngIf="someCommentsDeleted" class="pl-2 text-right text-nowrap">
                <input id="show-deleted" type="checkbox" name="Show Deleted" (change)="showDeletedChecked($any($event.target).checked)" [checked]="showDeleted">
                <label for="show-deleted" class="small pl-sm-1">Show Deleted</label>
            </div>
        </div>
</div>
</div>

